import React, { useEffect, useState } from "react";
import moment from "moment";
import Loader from "../Common/Loader";
import CommonService from "../../services/common.service";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";

const PointSystem = () => {
  useAutoAddQueryString();
  const [selectedGrade, setSelectedGrade] = useState(0);
  const [pointsListing, setPointsListing] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [gradeList, setGradeList] = useState([]);

  // Function to handle changes to the selected grade
  const handleGradeChange = (value) => {
    setSelectedGrade(value);
    CommonService.getGradePointSystem(selectedGrade).then((res) => {
      setPointsListing(res.data);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchRoundData();
    getDefaultPointSystem();
  }, []);

  const fetchRoundData = () => {
    CommonService.getGradeList().then((res) => {
      setGradeList(res.data);
      setIsLoading(false);
    });
  };
  const getDefaultPointSystem = () => {
    CommonService.getDefaultPointSystem(selectedGrade).then((res) => {
      setPointsListing(res.data);
      setSelectedGrade(res.gradeId);
      setIsLoading(false);
    });
  };
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Point System</h2>
            </div>

            <div className="tab-content">
              <div className="searchfilter">
                <select
                  id="gradeSelect"
                  value={selectedGrade}
                  onChange={(e) => handleGradeChange(e.target.value)}
                  className="selectdropdown"
                >
                  <option value="">Select</option> {/* Add a default option */}
                  {gradeList.map((item, key) => (
                    <option key={key} value={item?.id}>
                      {item?.grade}
                    </option>
                  ))}
                </select>
              </div>
              <table className="table table ranktable rankNewTableClass">
                <thead>
                  <tr>
                    <th>CATEGORY</th>
                    <th>GK</th>
                    <th>DEF</th>
                    <th>MID</th>
                    <th>FWD</th>
                  </tr>
                </thead>
                <tbody>
                  {pointsListing &&
                    pointsListing.map((item, key) => (
                      <tr key={key}>
                        <td>{item?.attribute_name}</td>
                        <td>{item?.gk}</td>
                        <td>{item?.def}</td>
                        <td>{item?.mid}</td>
                        <td>{item?.fwd}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PointSystem;
